import React from "react";
import { useHistoryTurns } from "../../../hooks/turns/useHistoryTurns";
import { TableModule } from "../../../components/home/TableModule";
import { HeaderModule } from "../../../components/home/HeaderModule";

export const HistoryTurns = ({ sede }) => {

    const { columns, total, historyTurns } = useHistoryTurns(sede);

    return (
        <>
            <HeaderModule
                icon={ <></> }
                title='Atendidos'
                component={ (
                    <div style={{ padding: '2px 5px', borderRadius: 6, background: '#00365F', display: 'flex', justifyContent: 'center', minWidth: 30, maxWidth: 50 }}>
                        <h3 style={{ color: '#fff' }}>{ total }</h3>
                    </div>
                ) }
            />

            <TableModule
                columns={ columns }
                rows={ historyTurns }
                styles={{
                    height: '40dvh',
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10
                }}
            />
        </>      
    );
}